import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        _user: null,
        _search: null,
    },
    getters:{
        user: (state) => {
            return state._user;
        },
        search: (state) => {
            return state._search;
        }
    },
    mutations: {
        SIMPAN_USER: (state, user) => {
            state._user = user;
        },
        SAVE_SEARCH: (state, search) => {
            state._search = search;
        }
    },
    actions: {
        simpanUser({ commit, state }, user) {
            commit('SIMPAN_USER', user)
        },
        saveSearch({ commit, state }, search) {
            commit('SAVE_SEARCH', search)
        }
    }
})

// export default new Vuex.Store({
//     state: {
//         isLoading: false,
//         listAgenda: [
//             { hari: 'senin', kegiatan: 'Belajar Vuejs' },
//             { hari: 'selasa', kegiatan: 'Belajar Laravel' },
//             { hari: 'rabu', kegiatan: 'Belajar Mysql' }
//         ]
//     },
//     mutations: {
//         KONFIRMASI_AGENDA: (state, agenda) => {
//             state.listAgenda.push(agenda)
//         }
//     },
//     actions: {
//         simpanAgenda({ commit, state }, agenda) {
//             state.isLoading = true
//             setTimeout(() => {
//                 commit('KONFIRMASI_AGENDA', agenda)
//                 state.isLoading = false
//             }, 1500)
//         }
//     }
// })